import React, { useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/free-solid-svg-icons';
import { faBookmark as farBookmark } from '@fortawesome/free-regular-svg-icons';
import classNames from 'classnames';
import { IQuestionBarProps } from './QuestionBar.types';
import LngDropDown from '../LngDropDown/LngDropDown';
import QuestionChoose from '../QuestionChoose/QuestionChoose';
import TheoryModal from '../TheoryModal/TheoryModal';
import ReadSpeaker from '../ReadSpeaker/ReadSpeaker';
import styles from './QuestionBar.module.css';

const QuestionBar: React.FC<IQuestionBarProps> = ({
  isLogged,
  onLngChange,
  onLngToggleClick,
  onToggleChangeLng,
  languageToggleState,
  selectedLang,
  onQuestionChange,
  lng,
  topic,
  defaultRoute,
  questionId,
  userLanguage,
  questionLngList,
  finishedExam,
  theoryId,
  isExam,
  isMarked,
  onAddToMarked,
  onAddToFavorite,
  isFavorite,
  questionList
}: IQuestionBarProps) => {
  const [showTheory, setShowTheory] = useState(false);

  const handleToFavorite = useCallback(() => {
    if (onAddToFavorite && questionId) {
      onAddToFavorite(questionList[questionId - 1].id);
    }
  }, [onAddToFavorite, questionId, questionList]);

  const handleToMarked = useCallback(() => {
    if (onAddToMarked && questionId !== null && questionId !== undefined) {
      onAddToMarked(questionList[questionId!].id);
    }
  }, [questionId, onAddToMarked, questionList]);

  const handleCloseTheoryModal = useCallback(() => {
    setShowTheory(false);
  }, [setShowTheory]);

  const handleOpenTheoryModal = useCallback(() => {
    setShowTheory(true);
  }, [setShowTheory]);

  return (
    <div className={styles.questionBtnList}>
      {isLogged && !isExam && onAddToMarked && (
        <button type="button" className={styles.questionBtnListItem} onClick={handleToMarked}>
          <i
            className={classNames({
              'icon-star-line': !isMarked,
              'icon-star-fill': isMarked
            })}
          />
        </button>
      )}
      {isLogged && isExam && onAddToFavorite && (
        <button type="button" className={styles.questionBtnListItem} onClick={handleToFavorite}>
          {isFavorite ? (
            <FontAwesomeIcon icon={faBookmark} size="lg" />
          ) : (
            <FontAwesomeIcon icon={farBookmark} size="lg" />
          )}
        </button>
      )}
      {!!(isLogged && theoryId) && (
        <>
          <button type="button" className={styles.questionBtnListItem} onClick={handleOpenTheoryModal}>
            <i className="icon-theory" />
          </button>
          <TheoryModal show={showTheory} onHide={handleCloseTheoryModal} theoryId={theoryId} />
        </>
      )}

      <ReadSpeaker className={styles.questionBtnListItem} lng={lng} />

      <QuestionChoose
        onQuestionChange={onQuestionChange}
        isExam={isExam}
        finishedExam={finishedExam}
        topic={topic}
        defaultRoute={defaultRoute}
        questionList={questionList}
        iconCls={styles.questionBtnListItem}
      />

      <LngDropDown
        onLngToggleClick={onLngToggleClick}
        onToggleChangeLng={onToggleChangeLng}
        userLanguage={userLanguage}
        lng={lng}
        onLngChange={onLngChange}
        languageToggleState={languageToggleState}
        selectedLang={selectedLang}
        iconCls={styles.questionBtnListItem}
        questionLngList={questionLngList}
      />
    </div>
  );
};

export default QuestionBar;
